import React from "react";
import "../../../../../css/games/funTarget/title.css"
import funTarget from "../../../../../../assets/titles/indie/target.svg";

export default function Title(props) {
    return <div className="fd text_center">
        <img className='targetTitleImg' src={funTarget}></img>
    </div>
}